export function trackEvent(name, params = {}) {
  if (process.env.NODE_ENV !== 'production') return
  if (typeof window.gtag === 'function') {
    window.gtag('event', name, params)
  }
}
